<div class="node-label"> {{ node.label }} </div>

<div class="node-value">
    <!-- Text data -->
    <span *ngIf="node.data.displayVal['type'] === 'text'">
        {{ value || node.data.displayVal['value'] }}
    </span>

    <!-- DateTime data -->
    <span *ngIf="node.data.displayVal['type'] === 'dateTime'">
        {{ (value && value !== 'null') ? value : (node.data.displayVal['value'] && node.data.displayVal['value'] !==
        'null') ? node.data.displayVal['value'] : null | date: 'M/d/yy, h:mm:ss a' }}
    </span>

    <!-- Boolean data -->
    <ng-container *ngIf="valDisplayType === 'checkbox'">
        <div *ngIf="node.label !== 'Rebirth' && node.label !== 'Reboot' && node.label !== treeMetricEvents.resetCount; else buttonField">
            <mat-checkbox [checked]="value === 'true' || node.data.displayVal['value'] === 'true'" color="primary" style="pointer-events: none;"></mat-checkbox>
        </div>

        <ng-template #buttonField>
            <button mat-raised-button (click)="triggerEvent(node.label)"> {{node.label === treeMetricEvents.resetCount ? 'Reset' : 'Submit' }}  </button>
        </ng-template>
    </ng-container>
</div>

<div class="node-timestamp"> {{ timestamp | date: 'M/d/yy, h:mm:ss a' }} </div>